"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HelpBrowse = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _App = _interopRequireDefault(require("./components/App"));

var _ErrorBoundary = _interopRequireDefault(require("./components/ErrorBoundary"));

var _ScrollToTop = _interopRequireDefault(require("./components/ScrollToTop"));

var _store = require("./store");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var HelpBrowse =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(HelpBrowse, _PureComponent);

  function HelpBrowse(props) {
    var _this;

    _classCallCheck(this, HelpBrowse);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HelpBrowse).call(this, props));
    _this.state = {
      storeReady: false
    };
    return _this;
  }

  _createClass(HelpBrowse, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var env;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                env = this.props.env;
                _context.next = 3;
                return (0, _store.initializeStore)({
                  env: env
                });

              case 3:
                this.setState({
                  storeReady: true
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          env = _this$props.env,
          market = _this$props.market,
          topicId = _this$props.topicId;
      var storeReady = this.state.storeReady;
      var initialEntries = topicId ? ['/', "/topic/".concat(topicId)] : ['/'];
      var initialIndex = topicId ? 1 : 0;

      if (storeReady) {
        var _store$getState$app = _store.store.getState().app,
            historyEntries = _store$getState$app.historyEntries,
            historyIndex = _store$getState$app.historyIndex;

        if (historyEntries.length) {
          initialEntries = historyEntries;
          initialIndex = historyIndex;
        }
      }

      return storeReady ? _react.default.createElement(_ErrorBoundary.default, null, _react.default.createElement(_reactRedux.Provider, {
        store: _store.store
      }, _react.default.createElement(_reactRouterDom.MemoryRouter, {
        initialEntries: initialEntries,
        initialIndex: initialIndex
      }, _react.default.createElement(_ScrollToTop.default, null, _react.default.createElement(_App.default, {
        env: env,
        market: market
      }))))) : null;
    }
  }]);

  return HelpBrowse;
}(_react.PureComponent);

exports.HelpBrowse = HelpBrowse;
HelpBrowse.propTypes = {
  env: _propTypes.default.string.isRequired,
  market: _propTypes.default.string.isRequired,
  topicId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};
var _default = HelpBrowse;
exports.default = _default;